/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_Submitted_SuccessInputs */

const en_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic AD job submitted successfully. You can monitor progress in the AD Import Dashboard.`)
};

const fr_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâche d'importation AD automatique soumise avec succès. Vous pouvez suivre sa progression dans le tableau de bord d'importation AD.`)
};

const de_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der automatische AD-Importauftrag wurde erfolgreich übermittelt. Sie können den Fortschritt im AD-Import-Dashboard verfolgen.`)
};

const it_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processo automatico di Active Directory inviato correttamente. È possibile monitorare l'avanzamento nella dashboard di importazione di Active Directory.`)
};

const ru_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое задание для Active Directory успешно отправлено. Вы можете отслеживать ход выполнения на панели мониторинга импорта Active Directory.`)
};

const es_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tarea automática de AD se ha enviado correctamente. Puede supervisar el progreso en el Panel de importación de AD.`)
};

const zh_cn2_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动 AD 作业已成功提交。您可以在 AD 导入仪表板中监控进度。`)
};

const ja_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動ADジョブが正常に送信されました。ADインポートダッシュボードで進捗状況を監視できます。`)
};

const hi_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटोमैटिक AD जॉब सफलतापूर्वक सबमिट हो गया है। आप AD इंपोर्ट डैशबोर्ड में इसकी प्रगति देख सकते हैं।`)
};

const pt_pt2_ad_job_submitted_success = /** @type {(inputs: Ad_Job_Submitted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa automática do Active Directory enviada com sucesso. Você pode acompanhar o progresso no Painel de Importação do Active Directory.`)
};

/**
* | output |
* | --- |
* | "Automatic AD job submitted successfully. You can monitor progress in the AD Import Dashboard." |
*
* @param {Ad_Job_Submitted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_submitted_success = /** @type {((inputs?: Ad_Job_Submitted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_Submitted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_job_submitted_success(inputs)
	if (locale === "de") return de_ad_job_submitted_success(inputs)
	if (locale === "it") return it_ad_job_submitted_success(inputs)
	if (locale === "ru") return ru_ad_job_submitted_success(inputs)
	if (locale === "es") return es_ad_job_submitted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_job_submitted_success(inputs)
	if (locale === "ja") return ja_ad_job_submitted_success(inputs)
	if (locale === "hi") return hi_ad_job_submitted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_job_submitted_success(inputs)
	return en_ad_job_submitted_success(inputs)
});